import { isNil, never } from "@vendrinc/frontend-ts";
import * as React from "react";
import { FlagName } from "~/domain/featureFlags";

export type State = {
  trackedExperiments: ReadonlyMap<FlagName, unknown>;
};

export type Action = { type: "add"; key: FlagName; value: unknown };

export const init = (): State => {
  return {
    trackedExperiments: new Map(),
  };
};

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case "add": {
      const copiedTrackedExperiments = new Map(state.trackedExperiments);
      copiedTrackedExperiments.set(action.key, action.value);
      return {
        ...state,
        trackedExperiments: copiedTrackedExperiments,
      };
    }
    default:
      return never(action.type);
  }
};

export const hasTrackedExperiment =
  (state: State) =>
  (key: FlagName, value: unknown): boolean => {
    const trackedValue = state.trackedExperiments.get(key);

    if (isNil(trackedValue)) {
      return false;
    }

    return trackedValue === value;
  };

export const StateContext = React.createContext(init());

export const DispatchContext = React.createContext<React.Dispatch<Action>>(
  () => {},
);
